__turbopack_context__.v({
  "item": "_1sfU4G_item",
  "itemHighlighted": "_1sfU4G_itemHighlighted",
  "itemSelected": "_1sfU4G_itemSelected",
  "itemWrapper": "_1sfU4G_itemWrapper",
  "panel": "_1sfU4G_panel",
});
